L.Control.Carousel = L.Control.extend( {

    includes: ((typeof L.Evented !== 'undefined' && L.Evented.prototype) || L.Mixin.Events),

    clicked: false,     // the carousel does some crazy stuff, so use this to track if user input was used
    drawnCharts: false, // used for lazy drawing of charts

    initialize: function (id, options) {
	this.flkty = new Flickity('.carousel', { adaptiveHeight: true });
	this.flkty.on( 'change', L.bind(this._select, this) );
	this.clear();
    },

    _isExpanded: function() {
        return document.querySelector('.carousel').classList.contains('expanded');
    },

    resize: function() {
        this.flkty.resize();
    },

    _toggleElevation: function(e) {
        this.clicked = true;
	document.querySelector('.carousel').classList.toggle('expanded');
        var expanded = this._isExpanded();
	//this.flkty.resize();
	var btns = document.querySelectorAll('.elevation-toggle i');
	for (var j = 0, len = btns.length; j < len; j++) {
             if (expanded) {
                btns[j].classList.add('fa-caret-down');
                btns[j].classList.remove('fa-caret-up');
             } else {
                btns[j].classList.remove('fa-caret-down');
                btns[j].classList.add('fa-caret-up');
             }
	}
        var charts = document.querySelectorAll('.elevation-chart');
        for (var j = 0, len = charts.length; j < len; j++) {

             if (!this.drawnCharts) {
                this._plotChart(this.routes[j], charts[j]);
             }

             if (expanded) {
                charts[j].classList.remove('hidden');
             } else {
                charts[j].classList.add('hidden');
             }
        }
        this.drawnCharts = true;
        this.clicked = false;
        this.flkty.resize();
    },

    _select: function(index) {
        var j = index;
        if (this.clicked || !this.routes || this.routes.length == 0)
           return;

        var alts = this.routes.slice();
        var route = alts.splice(j, 1)[0];

        control.fire('routeselected', {
           route: route,
           alternatives: alts
        });
    },

    refresh: function() {
        this.setRoutes(this.routes || [], this.flkty.selectedIndex);
    },

    setRoutes: function(routes, selectedIndex) {
        this.clicked = true;
        this.drawnCharts = false;
        this.routes = routes;
        this._removeAll();
        for (var j = 0, len = routes.length; j < len; j++) {
            var cell = this._createCell( routes[j] );
            this.flkty.append( cell );
        }
        if (routes.length == 0) {
           this.flkty.append( this._createCell() ); 
        }
        this.flkty.select(selectedIndex || 0,false,true);
        if (routes.length > 1) {
           this.showButtons();
        } else {
           this.hideButtons();
        }
        this.clicked = false;
    },

    _removeAll: function() {
        var cells = document.querySelectorAll('.carousel-cell');
        for (var j = 0, len = cells.length; j < len; j++) {
            this.flkty.remove(cells[j]);
        }
    },

    clear: function() {
        this.setRoutes([]);
    },

    _createCell: function(route) {
        var distance = route ? route.summary.totalDistance : 0;
        var expanded = this._isExpanded();
        var cell = L.DomUtil.create('div','carousel-cell');
        var toggle = L.DomUtil.create('div','elevation-toggle', cell);
        L.DomEvent.on(toggle, 'click', this._toggleElevation, this);
        var icon = L.DomUtil.create('i',expanded ? 'fa fa-caret-down': 'fa fa-caret-up', toggle); 

        var chart = L.DomUtil.create('div','elevation-chart '+ (expanded ? '' : 'hidden'), cell);
        if (expanded) {
           this._plotChart(route, chart);
           this.drawnCharts = true;
        }

        var imperial = control.getPlan().options.imperialUnits;
        var distel = L.DomUtil.create('div','distance', cell);
        distel.innerHTML = this._formatDistance(distance, imperial ? 'mi' : 'km');

        return cell;
    },

    hideButtons: function() {
        var btns = document.querySelectorAll('.flickity-prev-next-button');
        for (var j = 0, len = btns.length; j < len; j++) {
            if (!btns[j].classList.contains('.hidden')) {
                btns[j].classList.add('hidden');
            }
        }
    },

    showButtons: function() {
        var btns = document.querySelectorAll('.flickity-prev-next-button');
        for (var j = 0, len = btns.length; j < len; j++) {
            btns[j].classList.remove('hidden');
        }
    },

    _getWayTypeElement: function(route) {
        var html = "";
        for (var wayType in route.summary.wayTypes) {
            var num = Math.round( route.summary.wayTypes[wayType] );
            if (num <= 0) continue;
            var label;
            switch(wayType) {
               case "unknown": label=L.localisation.get('routeDetail.pathTypeUnknown'); break;
               case "state_road": label=L.localisation.get('routeDetail.pathTypeMajorRoad'); break;
               case "road": label=L.localisation.get('routeDetail.pathTypeMinorRoad'); break;
               case "street": label=L.localisation.get('routeDetail.pathTypeResidentialRoad'); break;
               case "path": label=L.localisation.get('routeDetail.pathTypePath'); break;
               case "track": label=L.localisation.get('routeDetail.pathTypeTrack'); break;
               case "cycleway": label=L.localisation.get('routeDetail.pathTypeCycleway'); break;
               case "footway": label=L.localisation.get('routeDetail.pathTypeFootpath'); break;
               case "steps": label=L.localisation.get('routeDetail.pathTypeSteps'); break;
               case "ferry": label=L.localisation.get('routeDetail.pathTypeFerry'); break;
               case "construction": label=L.localisation.get('routeDetail.pathTypeConstruction'); break;
            }
            html += label + " ("+num+"%), ";
        }
        return html.substring(0,html.length-2);
    },

    _plotChart: function(route, chart) {

        chart.innerHTML = '';
        var geojson = route ? route.geometry : null;
        var imperial = control.getPlan().options.imperialUnits;

        if (!geojson) {
           chart.classList.add('chart-empty');
           chart.innerHTML = L.localisation.get('routeDetail.elevationPlaceholder');
           this.flkty.resize();
           return;
        }

        var wayTypeElem = L.DomUtil.create('div', 'waytypes', chart);
        wayTypeElem.innerHTML = this._getWayTypeElement(route);

        Math.log10 = Math.log10 || function(x) {
           return Math.log(x) * Math.LOG10E;
        };

        var digits = route.geometry && route.geometry.coordinates ?
                     Math.ceil(Math.log10( Math.max.apply(Math, route.geometry.coordinates.map(function(o) { return o[2]; })) )) : 3;

        var margin = {top: 4, right: 10, bottom: 20, left: digits*12.5},
            width = 320 - margin.left - margin.right,
            height = 80 - margin.top - margin.bottom;

        var x = d3.scaleLinear().range([0, width]);
        var y = d3.scaleLinear().range([height, 0]);

        // Define the axes
        var xAxis = d3.axisBottom(x).ticks(5);
        var yAxis = d3.axisLeft(y).ticks(5);

        var valueline = d3.line()
            .x(function(d) { return x(d.distance); })
            .y(function(d) { return y(d.elevation); });

        var svg = d3.select(chart)
            .append('svg')
                .attr('width', width + margin.left + margin.right)
                .attr('height', height + margin.top + margin.bottom)
            .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        var data = geojson.coordinates.reduce(function(a, c) {
            var ll = L.latLng([c[1], c[0], c[2]]),
                elevDiff,
                dist;

            if (a.lastLatLng) {
                dist = a.lastLatLng.distanceTo(ll);
                a.accDist += dist;
                //elevDiff = ll.alt - a.lastLatLng.alt;
                //if (elevDiff > 0) {
                //    a.accClimb += elevDiff;
                //} else {
                //    a.accDesc -= elevDiff;
                //}
            }

            a.data.push({
                distance: imperial ? a.accDist/1609.344 : a.accDist/1000,
                elevation: imperial ? c[2]*3.281 : c[2]
            });
            a.lastLatLng = ll;
            return a;
        }, {
            accDist: 0,
            accClimb: route.summary.totalAscend,
            accDesc: route.summary.totalDescend,
            data: []
        });

        var statsElem = L.DomUtil.create('div', 'stats', chart);
        statsElem.innerHTML =
            L.Util.template('&#9650;{climb}, &#9660;{desc}', {
                climb: this._formatDistance(data.accClimb, imperial ? 'ft' : 'm'),
                desc: this._formatDistance(data.accDesc, imperial ? 'ft' : 'm')
            });

        // Scale the range of the data
        x.domain([0, d3.max(data.data, function(d) { return d.distance; })]);
        y.domain([Math.floor(d3.min(data.data, function(d) { return d.elevation; }) / 50) * 50,
                  Math.ceil(d3.max(data.data, function(d) { return d.elevation; }) / 50) * 50]);

        // Add the valueline path.
        svg.append('path')
            .attr('class', 'line')
            .attr('d', valueline(data.data));

        // Add the X Axis
        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

        // Add the Y Axis
        svg.append('g')
            .attr('class', 'y axis')
            .call(yAxis);

        this.flkty.resize();
    },

    _formatDistance: function(distance /*metres*/, unit) {
       if (unit == 'km')
         return (distance/1000).toFixed(2)+' km';
       if (unit == 'mi')
         return (distance/1609.344).toFixed(2)+' mi';
       if (unit == 'ft')
         return Math.round(distance*3.281)+' ft';
       return Math.round(distance)+' m';
    }

});
